/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
import m from "mithril";

export default {
  oninit({ state, attrs }) {
    state.mapId = Math.random()
      .toString()
      .split(".")[1];
  },
  oncreate({ state, attrs }) {
    const points = [];
    const markerMap = {};

    attrs.gpsData.map(x => points.push(...x));

    if (points.length === 0) {
      state.map = new google.maps.Map(document.getElementById(state.mapId), {
        center: new google.maps.LatLng(0, 0),
        zoom: Math.ceil(Math.log2($(window).width())) - 8
      });

      var worldBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(70.4043, -143.5291), //Top-left
        new google.maps.LatLng(-46.11251, 163.4288) //Bottom-right
      );
      state.map.fitBounds(worldBounds, 0);
      var actualBounds = state.map.getBounds();
      if (
        actualBounds.getSouthWest().lng() == -180 &&
        actualBounds.getNorthEast().lng() == 180
      ) {
        state.map.setZoom(state.map.getZoom() + 1);
      }

      return;
    }

    if (points.length === 1) {
      const { lat, long: lng, meta } = points[0];

      // The map, centered at Uluru
      state.map = new google.maps.Map(document.getElementById(state.mapId), {
        zoom: 16,
        center: new google.maps.LatLng(lat, lng)
      });
      // The marker, positioned at Uluru
      state.marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: state.map
      });

      state.marker.addListener("click", () => {
        state.map.setZoom(16);
        state.map.setCenter(state.marker.getPosition());

        if (attrs.markerSelected) attrs.markerSelected(meta);
      });

      state.map.panTo(state.marker.getPosition());

      return;
    } else {
      // The map, centered at Uluru
      state.map = new google.maps.Map(document.getElementById(state.mapId), {
        zoom: 16,
        center: points[points.length - 1]
          ? new google.maps.LatLng(
              points[points.length - 1].lat,
              points[points.length - 1].long
            )
          : null
      });

      points.map(point => {
        const { lat, long: lng, meta } = point;

        markerMap[meta] = new google.maps.Marker({
          position: new google.maps.LatLng(lat, lng),
          map: state.map
        });

        markerMap[meta].addListener("click", () => {
          if (attrs.markerSelected) attrs.markerSelected(meta);
        });

        // state.map.panTo(state.marker.getPosition());
      });
    }
  },
  onupdate({ attrs, state }) {
    const points = [];

    attrs.gpsData.map(x => points.push(...x));

    if (points.length === 1) {
      if (state.markerPosition !== points[0]) {
        const { lat, long: lng, meta } = points[0];

        // remove the old marker
        if (state.marker) state.marker.setMap(null);

        // The marker, positioned at Uluru
        state.marker = new google.maps.Marker({
          position: new google.maps.LatLng(lat, lng),
          map: state.map
        });

        state.marker.addListener("click", () => {
          state.map.setZoom(16);
          state.map.setCenter(state.marker.getPosition());

          if (attrs.markerSelected) attrs.markerSelected(meta);
        });

        state.map.panTo(state.marker.getPosition());

        return;
      }
    }
  },
  view({ state, attrs }) {
    return m(
      "div",
      {
        class: "embed-responsive embed-responsive-16by9",
        style: {
          height: attrs.long !== true ? "" : "calc(100vh - 40px)"
        }
      },
      m("div", {
        class: "embed-responsive-item",
        id: state.mapId
      })
    );
  }
};
